module.exports = __webpack_public_path__ + "img/icon-try-on.white.90ed6a23.svg";